/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/firestore'
//import 'firebase/analytics'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import moment from 'moment'
import { VBPopover } from 'bootstrap-vue'
import BootstrapVue from 'bootstrap-vue'
import Popover from 'vue-js-popover'
import VCalendar from 'v-calendar';
import VueFriendlyIframe from 'vue-friendly-iframe';
import VueConfirmDialog from 'vue-confirm-dialog'
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios';
import 'sweetalert2/dist/sweetalert2.min.css';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;



Vue.config.productionTip = false
let app = ''

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment.unix(value).format('YYYY/MM/DD')
  }
})
Vue.use(BootstrapVue)
Vue.use(VCalendar)
Vue.use(VueFriendlyIframe);
Vue.use(VueConfirmDialog)
Vue.use(VueSweetalert2);
Vue.directive('b-popover', VBPopover)
//Vue.component('vue-multiselect', window.VueMultiselect.default)
Vue.component('flat-pickr', window.VueFlatpickr);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)




var firebaseConfig = {
  apiKey: "AIzaSyBPznnEnEVHt0tfFKxSXF8DcXj2HdEAMqY",
  authDomain: "canplast-mx.firebaseapp.com",
  databaseURL: "https://canplast-mx.firebaseio.com",
  projectId: "canplast-mx",
  storageBucket: "canplast-mx.appspot.com",
  messagingSenderId: "862464859401",
  appId: "1:862464859401:web:19ad54f3ebc7a645ad07d8",
  measurementId: "G-5MW0BHRGJS"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//firebase.analytics();

if(localStorage.getItem("token-cpm")){
  axios.defaults.headers.common['Authorization'] = localStorage.getItem("token-cpm")
}
/* 
  * * GET Token from the API
 */
axios
.post(`/api/login`, { email: process.env.VUE_APP_EMAIL_SIGN_IN })
.then((result) => {
  axios.defaults.headers.common['Authorization'] = result.data.token;
  localStorage.setItem("token-cpm", result.data.token);
})
.catch((error) => {
  console.log("🚀 ~ file: main.js ~ line 83 ~ error", error)
})
  

firebase.auth().onAuthStateChanged(() => {
  if(!app){
    app = Vue.use(ArgonDashboard, Popover)
    new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
});
